import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-card-list',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <p>cp-card-list works!</p> `,
  styles: ``,
})
export class CpCardListComponent {}
